import InputCustom from 'components/Inputs'
import InputVariable from 'components/Inputs/InputVariable'
import useRedux from 'hooks/useRedux'
import { useEffect, useState } from 'react'
import { RiMessage3Line } from 'react-icons/ri'
import { useSelector } from 'react-redux'
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  FormGroup,
  Label
} from 'reactstrap'
import { ApplicationState } from 'store'
import { ATENDIMENTO } from 'store/modules/atendimento/types'
import { CustomButton, SimpleTitleCard } from 'styles/global'
import * as atendimentoActions from 'store/modules/atendimento/actions'
import * as cadastroModelosActions from 'store/modules/backoffice/cadastroModelo/actions'
import CustomSelect from 'components/Select'
import * as yup from 'yup'
import { toast } from 'react-toastify'

interface Props {
  isOpen: boolean
  onToggle: () => void
  index: number
}

const ModalChatWoot = ({ isOpen, onToggle, index }: Props) => {
  const {
    atendimentosAbertos,
    inboxesChatwoot,
    agentesChatwoot,
    agenteChatwootSelected,
    inboxChatwootSelected
  } = useSelector<ApplicationState, ATENDIMENTO>((state) => state.atendimento)

  const { modeloMensagemSelect } = useSelector(
    (state: ApplicationState) => state.cadastroModelo
  )
  const { dispatch } = useRedux()

  const [message, setMessage] = useState<string>('')
  const [modeloSelecionado, setModeloSelecionado] = useState<string>('')
  const [errors, setErrors] = useState<{ invalid: boolean; field: string }[]>(
    []
  )
  const atendimento = atendimentosAbertos[index]

  const variables = [
    { descricao: 'nome Cliente', campoEquivalente: 'nome_cliente' },
    { descricao: 'nome Operador', campoEquivalente: 'nome_operador' },
    {
      descricao: 'valor da Oportunidade',
      campoEquivalente: 'valor_oportunidade'
    }
  ]

  const handleInboxChange = (id: string) => {
    dispatch(atendimentoActions.setInboxChatwootSelected(id))
  }

  useEffect(() => {
    if (isOpen) {
      dispatch(atendimentoActions.getAgentesChatwootSaga())
      dispatch(atendimentoActions.getInboxesChatwootSaga())
      dispatch(atendimentoActions.getAgenteSelecionadoChatWootSaga())
      dispatch(cadastroModelosActions.getModelosMensagemSaga())
    } else {
      dispatch(atendimentoActions.setAgenteChatwootSelected(null))
      dispatch(atendimentoActions.setInboxChatwootSelected(null))
      setModeloSelecionado('')
      setMessage('')
    }
  }, [isOpen, dispatch])

  useEffect(() => {
    if (modeloSelecionado && modeloMensagemSelect?.length) {
      const modelo = modeloMensagemSelect.find(
        (m) => m.id === modeloSelecionado
      )
      if (modelo) {
        setMessage(modelo.descricao)
      }
    }
  }, [modeloSelecionado, modeloMensagemSelect])

  if (!atendimento || !atendimento.tabContato) {
    return null
  }

  const agentesOptions = Array.isArray(agentesChatwoot) ? agentesChatwoot : []

  const validationSchema = yup.object().shape({
    agenteChatwootSelected: yup.string().required('Agente é obrigatório'),
    inboxChatwootSelected: yup.string().required('Conexão é obrigatória'),
    destinatario: yup.string().required('Destinatário é obrigatório'),
    message: yup
      .string()
      .required('Mensagem é obrigatória')
      .max(300, 'Mensagem deve ter no máximo 300 caracteres'),
    modeloSelecionado: yup.string()
  })

  const enviarMensagem = () => {
    validationSchema
      .validate(
        {
          agenteChatwootSelected,
          inboxChatwootSelected,
          destinatario: atendimento.tabContato.nome,
          message,
          modeloSelecionado
        },
        { abortEarly: false }
      )
      .then(() => {
        dispatch(
          atendimentoActions.criarMensagemChatwootSaga(index, 0, message)
        )
        dispatch(atendimentoActions.cleanModalChatwoot())
        setMessage('')
        onToggle()
      })
      .catch((err) => {
        const newErrors = err.inner.map((error: yup.ValidationError) => ({
          invalid: true,
          field: error.path
        }))
        setErrors(newErrors)
        toast.error('Por favor, corrija os erros no formulário.')
      })
  }

  return (
    <Modal
      size="md"
      isOpen={isOpen}
      toggle={() => onToggle()}
      backdrop="static"
    >
      <ModalHeader toggle={onToggle} className="d-flex align-items-center">
        <SimpleTitleCard>
          <RiMessage3Line className="icon me-2" />
          Preencha as informações para enviar mensagem:
        </SimpleTitleCard>
      </ModalHeader>

      <ModalBody>
        <FormGroup>
          <Label className="label-12">Agente*</Label>
          <CustomSelect
            options={agentesOptions}
            placeholder="Selecione o Agente"
            value={agenteChatwootSelected}
            onChange={(id) =>
              dispatch(atendimentoActions.setAgenteChatwootSelected(id))
            }
            accessorLabel="name"
            accessorValue="id"
            isClearable
            invalid={errors.some(
              (error) => error.field === 'agenteChatwootSelected'
            )}
          />
        </FormGroup>

        <FormGroup>
          <Label className="label-12">Conexão*</Label>
          <CustomSelect
            options={Array.isArray(inboxesChatwoot) ? inboxesChatwoot : []}
            placeholder={'Selecione a Conexão'}
            value={inboxChatwootSelected}
            onChange={(id) => handleInboxChange(id)}
            accessorLabel="name"
            accessorValue="id"
            isClearable
            invalid={errors.some(
              (error) => error.field === 'inboxChatwootSelected'
            )}
          />
        </FormGroup>

        <FormGroup>
          <Label className="label-12">Para</Label>
          <InputCustom
            type="text"
            value={atendimentosAbertos[index].tabContato.nome}
            disabled
          />
        </FormGroup>

        <FormGroup>
          <Label className="label-12">Mensagem*</Label>
          <InputVariable
            rawValue={message}
            onRawChange={(value) => {
              const trimmedValue = value.slice(0, 300)
              setMessage(trimmedValue)
            }}
            variables={variables}
            placeholder="Escreva sua mensagem aqui..."
            invalid={errors.some((error) => error.field === 'message')}
          />
          <small>{message.length}/300 caracteres</small>
        </FormGroup>

        <FormGroup>
          <Label className="label-12">Selecione o Modelo</Label>
          <CustomSelect
            options={
              Array.isArray(modeloMensagemSelect) ? modeloMensagemSelect : []
            }
            placeholder="Escolha um modelo"
            value={modeloSelecionado}
            onChange={(id) => {
              setModeloSelecionado(id)
              if (!id) setMessage('')
            }}
            accessorLabel="nome"
            accessorValue="id"
            isClearable
          />
        </FormGroup>
      </ModalBody>

      <ModalFooter>
        <Row className="d-flex column-gap-20 w-100 justify-content-center">
          <CustomButton background="#497a4bff" onClick={enviarMensagem}>
            Enviar
          </CustomButton>
          <CustomButton
            onClick={() => {
              onToggle()
              dispatch(atendimentoActions.cleanModalChatwoot())
              setMessage('')
            }}
            background="#E53935"
          >
            Cancelar
          </CustomButton>
        </Row>
      </ModalFooter>
    </Modal>
  )
}

export default ModalChatWoot
